import React, { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from '@material-ui/core';
import { GridCloseIcon } from '@mui/x-data-grid';
import styles from './SGSModalLight.module.scss';
import errorIcon from '../../assets/error_icon.svg';

interface ModalProps {
    isOpenModal: boolean;
    setIsOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
    title: string;
    titleIcon?: any;
    actionToolbar?: () => ReactNode;
    children: ReactNode;
    handleClose?: Function;
}

const SGSModalLight: FC<ModalProps> = ({ isOpenModal, setIsOpenModal, title, children, actionToolbar = null, handleClose = null, titleIcon = errorIcon }) => {
    handleClose =
        handleClose ||
        (() => {
            setIsOpenModal(false);
        });

    function BootstrapDialogTitle(props: any) {
        const { children, onClose, ...other } = props;

        return (
            <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
                {children}
                {onClose && (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        style={{
                            position: 'absolute',
                            width: 40,
                            height: 40,
                            right: 30,
                            top: 30,
                        }}
                    >
                        <GridCloseIcon
                            style={{
                                position: 'absolute',
                                right: 0,
                                top: 0,
                                width: 40,
                                height: 40,
                                color: '#2574A9',
                            }}
                        />
                    </IconButton>
                )}
            </DialogTitle>
        );
    }

    return (
        <Dialog
            open={isOpenModal}
            onClose={() => {
                handleClose();
            }}
            maxWidth="md"
            PaperProps={{
                style: { width: '100%', maxHeight: '80vh', borderRadius: 10, padding: '10px' },
            }}
        >
            <BootstrapDialogTitle onClose={handleClose} className={styles.header}>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Box display="flex" alignItems="center">
                        <img src={titleIcon} alt="titleIcon" className={styles.errorIcon} width={44} />
                        <span className={styles.header__text}>{title}</span>
                    </Box>
                </Box>
            </BootstrapDialogTitle>
            <DialogContent>
                <DialogContentText className={styles.modalContent} style={{}}>
                    {children}
                </DialogContentText>
            </DialogContent>
            <DialogActions className="mb-4" style={{ paddingRight: 70 }}>
                {actionToolbar && actionToolbar()}
            </DialogActions>
        </Dialog>
    );
};

SGSModalLight.propTypes = {
    isOpenModal: PropTypes.bool.isRequired,
    setIsOpenModal: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    actionToolbar: PropTypes.func,
    children: PropTypes.node.isRequired,
};

export default SGSModalLight;
